import { Trans } from '@lingui/react/macro';
import Button from '@web/components/Shared/Button';
import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Title = styled(Typography)``;
const Message = styled(Typography)``;
const WarningIcon = styled(Icon)``;

export const ErrorComponent = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Root>
      <WarningIcon type="warning" fontSize="extra-large" />
      <TextWrapper>
        <Title variant="h3">
          <Trans>Something went wrong.</Trans>
        </Title>
        <Message variant="big">
          <Trans>Please try again or contact support.</Trans>
        </Message>
      </TextWrapper>
      <Button onClick={handleRefresh}>
        <Trans>Retry</Trans>
      </Button>
    </Root>
  );
};
